<div class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary border-primary px-3 text-light">
        <h5 class="modal-title">
          {{ mode === 'request' ? 'Reset Password' : 'Set New Password' }}
        </h5>
      </div>

      <div class="modal-body bg-dark text-white p-3">
        <form [formGroup]="form" (ngSubmit)="submit()" class="d-flex flex-column align-items-end justify-contents-center">
          <div class="w-100 mb-3" *ngIf="mode === 'request'">
            <label for="inputEmail" class="form-label">Email address</label>
            <input id="inputEmail" formControlName="email" type="email" class="form-control" placeholder="Enter your email" required />
          </div>

          <div class="w-100 mb-3" *ngIf="mode === 'confirm'">
            <label for="inputPassword" class="form-label">New Password</label>
            <input id="inputPassword" formControlName="newPassword" type="password" class="form-control" placeholder="Enter new password" required />
          </div>

          <div class="d-flex align-items-center justify-content-between gap-2 w-100">
            <div class="text-start text-success" *ngIf="message">
              {{ message }}
            </div>
            <button class="btn btn-primary" type="submit" [disabled]="form.invalid || loading">
              {{ loading ? 'Processing...' : 'Submit' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>